const DeliveryMethod = ({
  displayName = '',
  isDeliveredByEmail = false,
  isUpdateRestricted = true,
  supportEmail = '',
} = {}) => ({
  displayName: String(displayName),
  isDeliveredByEmail: Boolean(isDeliveredByEmail),
  isUpdateRestricted: Boolean(isUpdateRestricted),
  supportEmail: String(supportEmail),
});

export default DeliveryMethod;

export type DeliveryMethodProps = ReturnType<typeof DeliveryMethod>;
